import styled from "styled-components";
import { Flex } from "../Flex";
import { getThemeMedia } from "../helpers";
export const Container = styled(Flex).attrs(() => ({ as: "nav" })) `
	// color tokens but with opacity --greys-50
	background: linear-gradient(180deg, rgba(246, 246, 246, 0.64) -23.12%, rgba(246, 246, 246, 0.32) 100%);
	backdrop-filter: blur(4px);

	border: 1px solid;
	// color tokens but with opacity --greys-200
	border-color: rgba(209, 209, 209, 0.25);

	a,
	button {
		padding: 0 28px;
	}

	@media screen {
		@media (max-width: ${getThemeMedia("medium")}) {
			button {
				order: -1;
			}
		}
	}
`;
//# sourceMappingURL=styles.js.map